import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app/App';
import './styles/globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register WebLLM Service Worker - Permanent Static File Implementation
if ('serviceWorker' in navigator) {
  // Defer service worker registration until browser is idle after first paint
  const registerSW = () => {
    navigator.serviceWorker.register('/sw-webllm.js', {
      scope: '/',
      updateViaCache: 'none'
    })
    .then((registration) => {
      console.log('✅ WebLLM Service Worker registered successfully:', registration.scope);
      console.log('✅ Models will persist across page reloads and browser restarts');

      // Handle service worker updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('🔄 WebLLM Service Worker updated');
            }
          });
        }
      });
    })
    .catch((error) => {
      console.log('⚠️ WebLLM Service Worker registration failed:', error);
      console.log('ℹ️ Models will run on main thread with IndexedDB persistence');
    });
  };

  // Use idle callback if available, otherwise delay 1 second
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(registerSW);
  } else {
    setTimeout(registerSW, 1000);
  }
} else {
  console.log('ℹ️ Service Workers not supported - models will not persist across sessions');
}
